<template>
  <v-container>
    <ScreenLoading :show="showLoading" />
    <v-row class="title text-h5 text-uppercase">
      <v-icon>fa-user</v-icon> &nbsp;
      {{ editPage ? $t('index.titleEdit') : $t('index.titleSearch') }}
    </v-row>
    <v-row class="content max-width">
      <AdminUserSearch
        v-show="!editPage"
        :user-list="userList"
        @search="search($event)"
        @add="add($event)"
        @detail="detail($event)"
        @del="del($event)"
        @clear="clear($event)"
      />
      <AdminUserEdit
        v-show="editPage"
        ref="userEdit"
        :user-details="userDetails"
        :validation="validations.edit"
        @edit="edit($event)"
        @del="del($event)"
        @back="back($event)"
      />
    </v-row>
    <Snackbar
      v-model="showSnackbar"
      :text="snackbarText"
      :color="snackbarColor"
      top
      right
    />
  </v-container>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import AdminUserSearch from './M0001AdminUserSearch.vue'
import AdminUserEdit from './M0001AdminUserEdit.vue'
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import DialogOptions from '@/components/functions/Common/mixins/DialogOptions'
import ScreenLoading from '@/base/components/atoms/AtScreenLoading'
import Snackbar from '@/components/functions/Common/plugins/Snackbar'

export default {
  name: 'UserIndex',
  components: {
    AdminUserSearch,
    AdminUserEdit,
    ScreenLoading,
    Snackbar
  },
  mixins: [ErrorDisplay, DialogOptions],
  data: function () {
    return {
      showLoading: false,
      showSnackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      editPage: false,
      searchCondCache: {}
    }
  },
  computed: {
    userList () {
      return this.$store.state.M0001AdminUser.userList
    },
    userDetails () {
      return this.$store.state.M0001AdminUser.userDetails
    },
    validations () {
      return this.$store.state.M0001AdminUser.validations
    }
  },
  mounted () {
    this.$emit('pageName', this.$t('pageName'))
    this.init()
  },
  methods: {
    init () {
      this.showLoading = true
      this.$store.dispatch('M0001AdminUser/init', {})
        .then(() => {
          this.showLoading = false
        }).catch((err) => {
          this.showLoading = false
          this.showError(err)
        })
    },
    search (event) {
      this.showLoading = true
      this.$store.dispatch('M0001AdminUser/search', event)
        .then(() => {
          this.showLoading = false
          this.searchCondCache = JSON.parse(JSON.stringify(event))
        }).catch((err) => {
          this.showLoading = false
          this.showError(err)
        })
    },
    add (event) {
      this.editPage = true
    },
    detail (event) {
      this.showLoading = true
      this.$store.dispatch('M0001AdminUser/detail', { id: event.id })
        .then(() => {
          this.showLoading = false
          this.editPage = true
        }).catch((err) => {
          this.showLoading = false
          this.showError(err)
        })
    },
    edit (event) {
      this.showLoading = true
      this.$store.dispatch('M0001AdminUser/edit', event)
        .then(() => {
          this.showLoading = false
          this.editPage = false
          this.$refs.userEdit.init()
          this.search(this.searchCondCache)
          this.snackbarText = (event.id ? this.$t('edit.editSuccess') : this.$t('edit.addSuccess'))
          this.showSnackbar = true
        }).catch((err) => {
          console.log(err)
          let showErr = true
          this.showLoading = false
          if (err.message === '0001') err.message = this.$t('error.duplicateId')
          else showErr = false
          this.showError(err, showErr)
        })
    },
    del (event) {
      const message = {
        title: this.$t('common.delete'),
        body: this.$t('common.deleteConfirm', { item: event.login_id })
      }

      this.$dialog.confirm(message, this.dialogOptions)
        .then((dialog) => {
          this.showLoading = true
          this.$store.dispatch('M0001AdminUser/delete', { id: event.id })
            .then(() => {
              this.showLoading = false
              this.editPage = false
              this.$refs.userEdit.init()
              this.search(this.searchCondCache)
              this.snackbarText = this.$t('edit.deleteSuccess')
              this.showSnackbar = true
            }).catch((err) => {
              this.showLoading = false
              this.showError(err)
            })
        })
    },
    back (event) {
      this.editPage = false
    },
    clear (event) {
      this.$store.dispatch('M0001AdminUser/clear')
    }
  }
}
</script>

<style scoped>
.title, .content {
  margin: 20px;
}

.max-width {
  width: 100%
}
</style>
